import React, { useEffect, useState, useRef } from 'react';
import {
  Globe, Search, ShieldCheck, Headphones, Compass
} from 'lucide-react';
import "react-datepicker/dist/react-datepicker.css";
import HandpickedPackages from "./HandpickedPackages"
import useDocumentTitle from '../../hooks/useDocumentTitle'
import { getavailableDestination, holidaysearchresult, clearHolidayData } from './HolidaySlice';
import { useDispatch } from "react-redux";
import { toast } from 'react-hot-toast';
import { NavLink } from "react-router-dom";
import {
  startOfDay
} from "date-fns";
import { getSiteName } from '../../api/axios';
export default function Holiday() {
  useDocumentTitle('Package Search');
  const dispatch = useDispatch();
  const currencyRef = useRef(null);
  const [suggestions, setSuggestions] = useState([]);
  const slides = [
    {
      image: "/images/banner1.jpg",
      subtitle: "Jai Hind Sound & Light Show",
      title: "Where Every Experience Counts!"
    },
    {
      image: "/images/banner2.jpg",
      subtitle: "Europe Tour Packages",
      title: "Unforgettable Journeys Await"
    },
    {
      image: "/images/banner3.jpg",
      subtitle: "Romantic Honeymoon Escapes",
      title: "Celebrate Love Across The World"
    }
  ];

  const clickpaytripCategories = [
    { name: "Dubai", image: '/images/dubai.png', url: '#' },
    { name: "Vietnam", image: '/images/Vietnam.png', url: '#' },
    { name: "Thailand", image: '/images/Thailand.png', url: '#' },
    { name: "Bali", image: '/images/Bali.png', url: '#' },
    { name: "Seasonal Packages", image: '/images/Seasonal.png', url: '#' }
  ];
  const defaultCategories = [
    // { name: "Easy Book", tag: "NEW", image: '/images/honymn_holsm.png' },
    { name: "Weekend", image: '/images/Weekend.png', url: '/Holidays/weekend' },
    { name: "Honeymoon", image: '/images/honymn_holsm.png', url: '/Holidays/honeymoon' },
    { name: "Pilgrimage", image: '/images/Pilgrimage.png', url: '/Holidays/umrah' },
    { name: "Family", image: '/images/family.png', url: '/Holidays/family' },
    { name: "Adventure", image: '/images/Adventure.png', url: '/Holidays/adventure' }
  ];
  const categories = getSiteName() === 'clickpaytrip' ? clickpaytripCategories : defaultCategories;
  const [current, setCurrent] = useState(0);
  const [query, setQuery] = useState("");
  const [showSuggest, setShowSuggest] = useState(false);

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [SearchId, seSearchId] = useState('');
  let postData = {
    customer_id: 0
  }
  const SearchHolidayData = async () => {
    const payload = {
      "searchData": {
        "isApiSearch": true,
        "getAllPackage": true,
        "searchQuery": {
          "searchCriteria": {
            "dest_city": null,
            "dest_city_id": null,
            "dest_countryName": "",
            "adults": 1,
            "children": 0,
            "infant": "0",
            "childwob": "0"
          },
          "DepartureCriteria": {
            "dep_city": null,
            "dep_city_id": null,
            "dep_countryName": null,
            "checkinDate": "null",
            "nights": "1"
          },
          "searchPreferences": {
            "packageThemes": null,
            "hotelStars": "1,2,3,4,5"
          },
          "currency": {
            "CurrencyRate": "1.000000",
            "CurrencyTitle": "INR",
            "CurrencyId": 1
          }
        }
      },
      "page": 1
    }
    try {
      setLoading(true)
      dispatch(clearHolidayData())
      const response = await dispatch(holidaysearchresult(payload)).unwrap();
      setResults(response.data.data)
      seSearchId(response.data?.SearchId)
      setLoading(false)
      if (!response?.data?.success) {
        setLoading(false)
        toast.error(response?.data?.message, { autoClose: 3000 });
        // navigate(`/hotel`);
      }
    } catch (err) {
      console.error("Hotel search or fetch result failed:", err);
    }
  };

  const fetchDestination = async () => {
    try {
      const response = await dispatch(
        getavailableDestination({ postData })
      ).unwrap();
      const Resultdata = response.data;

      if (Resultdata.status.success) {
        setSuggestions(Resultdata.data);
      }
    } catch (error) {
      toast.error('Unbale to load destination', { autoClose: 3000 });
    }
  }
  // Auto slide
  useEffect(() => {
    SearchHolidayData()
    fetchDestination()
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        currencyRef.current &&
        !currencyRef.current.contains(event.target)
      ) {
        setShowSuggest(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const filteredSuggestions = suggestions.filter(item =>
    item.name.toLowerCase().includes(query.toLowerCase())
  );


  const ThemeIcon = ({ icon, label, badge }) => (
    <div className="flex flex-col items-center group cursor-pointer relative">
      {badge && (
        <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] px-2 py-0.5 rounded-full z-10 animate-pulse">
          {badge}
        </span>
      )}
      <div className="w-20 h-20 bg-white rounded-full shadow-lg flex items-center justify-center group-hover:shadow-blue-200 transition-all border border-blue-50">
        {React.cloneElement(icon, { size: 32 })}
      </div>
      <span className="mt-3 font-semibold text-gray-700 text-sm">{label}</span>
    </div>
  );
  const BenefitItem = ({ icon, title, desc }) => (
    <div className="flex items-center gap-4">
      <div className="bg-gray-50 p-3 rounded-2xl">{icon}</div>
      <div>
        <h4 className="font-bold text-gray-800">{title}</h4>
        <p className="text-xs text-gray-500">{desc}</p>
      </div>
    </div>
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (calendarRef.current && !calendarRef.current.contains(e.target)) {
        setShowCalendar(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [travelDate, setTravelDate] = useState(null); // YYYY-MM-DD
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef(null);
  // tomorrow date
  const tomorrow = startOfDay(new Date());

  // format helpers
  const formatStoreDate = (date) =>
    date.toISOString().split("T")[0]; // YYYY-MM-DD

  const formatDisplayDate = (date) =>
    date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });

  const [formData, setFormData] = useState({
    city: "",
    cityCode: "",
    checkIn: "",
  });
  const handleCitySelect = (city) => {
    setFormData(prev => ({
      ...prev,
      city: city.name,
      cityCode: city.cityCode.toString(),
    }));

    const params = new URLSearchParams({
      cityname: encodeURIComponent(city.name),
      checkin_date: travelDate,
      adults: 1,
      childs: 0,
      cityCode: city.cityCode.toString(),
    });
    window.location.href = `/Holidays/Search?${params.toString()}`;
    setShowSuggest(false);
  };
  const handleShowHotels = (e) => {
    e.preventDefault();

    if (!formData.city) {
      toast.error('Please select a city');
      return false;
    }

    // if (!travelDate) {
    //   toast.error('Please select Departure dates');
    //   return false;
    // }

    const params = new URLSearchParams({
      cityname: encodeURIComponent(formData.city),
      checkin_date: travelDate,
      adults: 1,
      childs: 0,
      cityCode: formData.cityCode.toString(),
    });

    window.location.href = `/Holidays/Search?${params.toString()}`;
    return false;
  };

  return (
    <>
      <div className="bg-gray-100 text-gray-800 relative min-h-screen">
        <main className="max-w-7xl mx-auto ">
          <div className="bg-white min-h-screen font-sans">
            {/* <SearchForm /> */}

            <section className="relative">
              {/* Slider */}
              <div className="relative h-[350px]">
                {slides.map((slide, idx) => (
                  <div
                    key={idx}
                    className={`absolute inset-0 transition-opacity duration-1000 ${current === idx ? "opacity-100" : "opacity-0"
                      }`}
                    style={{
                      backgroundImage: `url(${slide.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center"
                    }}
                  />
                ))}

                {/* Overlay */}
                <div className="absolute inset-0 bg-black/40" />

                {/* Content */}
                <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
                  <p className="text-white text-xl italic mb-2 transition-all duration-700">
                    {slides[current].subtitle}
                  </p>

                  <h1 className="text-white text-3xl md:text-4xl font-bold mb-6 transition-all duration-700">
                    {slides[current].title}
                  </h1>

                  {/* Search */}
                  <form onSubmit={handleShowHotels}>
                    <div className="relative w-full lg:w-[800px] mx-auto" ref={currencyRef}>
                      <div className="flex bg-white rounded-full overflow-hidden shadow-lg w-full">
                        {/* Destination */}
                        <div className="flex items-center flex-1">
                          <div className="flex items-center px-4 text-gray-400">
                            <Search size={20} />
                          </div>

                          <input
                            type="text"
                            value={query}
                            onChange={(e) => {
                              setQuery(e.target.value);
                              setShowSuggest(true);
                            }}
                            onFocus={() => setShowSuggest(true)}
                            placeholder="Your Dream Destination!"
                            className="w-full py-4 outline-none text-gray-700 text-base"
                          />
                        </div>
                        {/* Search Button */}
                        <button type='submit' className="bg-orange-500 hover:bg-orange-600 text-white px-10 font-semibold rounded-full">
                          Search
                        </button>
                      </div>

                      {/* Suggestion box */}
                      {showSuggest && (
                        <div className="absolute left-0 right-0 mt-1 bg-white rounded-2xl shadow-xl z-50 ">

                          {/* Header */}
                          <div className="flex items-center gap-3 px-5 py-2 border-b">
                            <div className="h-9 w-9 rounded-full border flex items-center justify-center text-gray-500">
                              📍
                            </div>
                            <p className="font-semibold text-lg">
                              Available <span className="font-normal">Holiday Destinations</span>
                            </p>
                          </div>

                          {/* List */}
                          <ul className="max-h-[260px] overflow-auto">
                            {filteredSuggestions.length ? (
                              filteredSuggestions.map((item, idx) => (
                                <li
                                  key={idx}
                                  onClick={() => {
                                    setQuery(item.name);
                                    handleCitySelect(item);
                                  }}
                                  className="flex items-center gap-4 px-5 py-3 hover:bg-gray-50 cursor-pointer"
                                >
                                  <img
                                    src={item.image || '/images/des-placeholder.png'}
                                    alt={item.name}
                                    className="h-12 w-12 rounded-lg object-cover"
                                  />
                                  <div className="flex flex-col text-left">
                                    <span className="text-lg font-medium leading-tight">
                                      {item.name}
                                    </span>
                                    <span className="text-sm text-gray-500">
                                      {item.fullRegionName}
                                    </span>
                                  </div>
                                </li>
                              ))
                            ) : (
                              <li className="px-5 py-4 text-gray-500">
                                No destinations found
                              </li>
                            )}
                          </ul>
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>


              <div className="relative -mt-10">
                <div className="max-w-4xl mx-auto bg-white rounded-full shadow-xl px-6 py-4 flex justify-between items-center overflow-x-auto gap-4">
                  {categories.map((cat, idx) => (
                    <NavLink
                      key={idx}
                      to={cat.url}   // 👈 make sure each category has a path
                      className="flex items-center gap-3 whitespace-nowrap cursor-pointer"
                    >
                      <div className="w-12 h-12 rounded-full bg-gray-200 overflow-hidden">
                        <img src={cat.image} alt={cat.name} className="w-full h-full object-cover" />
                      </div>

                      <div className="font-medium relative">
                        {cat.name}

                        {cat.tag && (
                          <span className="absolute -top-4 -right-6 bg-pink-500 text-white text-xs px-2 py-0.5 rounded-full">
                            {cat.tag}
                          </span>
                        )}
                      </div>
                    </NavLink>
                  ))}
                </div>
              </div>

              <div className="max-w-7xl mx-auto px-4 py-12 space-y-8">
                <HandpickedPackages results={results} loading={loading} />

                <section className="bg-white p-8 rounded-3xl border border-gray-100 shadow-sm grid grid-cols-1 md:grid-cols-4 gap-8">
                  <BenefitItem icon={<Globe className="text-blue-500" />} title="Wide Reach" desc="Covering 500+ destinations" />
                  <BenefitItem icon={<Compass className="text-orange-500" />} title="Expert Guided" desc="Hassle-free planning" />
                  <BenefitItem icon={<ShieldCheck className="text-green-500" />} title="Safe & Secure" desc="100% Secure payments" />
                  <BenefitItem icon={<Headphones className="text-purple-500" />} title="24x7 Help" desc="Always there for you" />
                </section>
              </div>
            </section>
          </div>
        </main>
      </div>
    </>
  );
}
